import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Input,
  Modal,
  Row,
  // Switch,
  Typography,
  // Skeleton,
} from "antd";
// import {
// us
// }
// from "@ant-design/icons";
import "./index.css";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { emailIsValid } from "../Auth/validations";
import { PiUserSoundFill } from "react-icons/pi";
import { isEmpty } from "lodash";
import api from "../../helpers";
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

const AccountSettings = (props) => {
  const history = useHistory();
  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  const [response, setResponse] = useState("");
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const { organization_list = [] } = useSelector((state) => state.Organisation);

  console.log(organization_list, "organization_list");
  // mobile & email from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = !isEmpty(userName) ? JSON.parse(userName) : "";

  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const userInfoMobile =
    !isEmpty(organization_list) &&
    organization_list !== undefined &&
    organization_list.organizationPhone
      ? organization_list.organizationPhone
      : "";
  const userInfoEmail =
    !isEmpty(organization_list) &&
    organization_list !== undefined &&
    organization_list.organizationEmail
      ? organization_list.organizationEmail
      : "";

  console.log(userInfoEmail, "userInfoEmail");

  //user account api response

  const userProfileDetails = localStorage.getItem("accountDetails");
  const userDetails =
    userNameDetails && userProfileDetails ? JSON.parse(userProfileDetails) : "";
  const userDetailsMobile = userDetails ? userDetails.mobileNo : "";
  const userDetailsName = userDetails ? userDetails.name : "";
  const userDetailsMail = userDetails ? userDetails.email : "";

  console.log(userDetails, "userDetails");
  console.log(userProfileDetails, "userProfileDetails");
  //local state values
  const [accountData, setAccountData] = useState({
    name: "",
    mobileNumber: "",
    referralCode: "",
  });
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setAccountData({
      name: !isEmpty(userDetailsName) ? userDetailsName : userDetailsName,
      mobileNumber: !isEmpty(userDetailsMobile)
        ? userDetailsMobile
        : userDetailsMobile,
    });

    const emailUser = !isEmpty(userDetailsMail)
      ? userDetailsMail
      : userDetailsMail;
    setEmail(emailUser);
    if (userProfileDetails) {
      setResponse(userProfileDetails);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userProfileDetails, organization_list]);

  console.log(response, "response");
  console.log(error, "error");
  //State data section

  //Onchange state values
  const handleChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      mobileNumber: /^[0-9]\d*\.?\d*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setAccountData({
          ...accountData,
          [name]: value,
        });
      }
    } else {
      setAccountData({
        ...accountData,
        [name]: value,
      });
    }
  };

  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
    } else {
      document.getElementById("error-panel").style.display = "none";
    }
  };

  //update api integrations
  const updateUserAccount = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 4000);
      const userAccountList = {
        id: userId,
        name: accountData.name,
        email: email,
      };

      api
        .put("/auth/users/updateaccount", userAccountList)
        .then((res) => {
          setResponse(res.data);
          console.log(res.data, "response");
          localStorage.setItem(
            "accountDetails",
            JSON.stringify(res.data.response)
          );
          // dispatch(loadOrganizationList(usersList));
          toast.success("Account updated successfully");
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          setError(error);
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(
            errorMsg || "There is a an issue while updating the account"
          );
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Account | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-md bg-[#ffffff] pb-10">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24}>
          <div className="account-settings-main pl-[10px] pr-[10px] mt-4">
            <div className="flex">
              <div className="ml-2 account-sub-header">
                <h1 className="text-[18px] mb-[1px] mt-2 font-semibold leading-tight">
                  Account Settings
                </h1>
                <p className="text-[12.5px]">
                  Manage your account and subscription
                </p>
              </div>
            </div>
            <div className="mt-3">
              <div className="flex">
                <div
                  onClick={() => {
                    setCancelConfirmation(true);
                  }}
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "13px",
                  }}
                  className="border rounded-md hover:bg-[#efefef] ml-3 pl-6 pr-6 p-1 cursor-pointer"
                >
                  Cancel
                </div>
                <div
                  style={{
                    opacity: isButtonDisabled ? 2 : "",
                    pointerEvents: isButtonDisabled ? "none" : "",
                    cursor: isButtonDisabled ? "not-allowed" : "pointer",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                  }}
                  onClick={() => updateUserAccount()}
                  className="border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-6 pr-6 p-1.5"
                >
                  Save Changes
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          md={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 && windowDimensions.height < 800
              ? "add-business-main-low-device"
              : windowDimensions.height > 800 && windowDimensions.height < 900
              ? "add-business-main-medium-devicen"
              : windowDimensions.height > 900 && windowDimensions.height < 1000
              ? "add-business-main-large-device"
              : windowDimensions.height >= 1000 &&
                windowDimensions.height < 1100
              ? "add-business-main-extra-large-device"
              : windowDimensions.height >= 1100
              ? "add-business-main-infinite-large-device"
              : "add-business-main"
          }
        >
          {/* <Col span={24} className="add-account-settings-main"> */}
          <Row className="suggestion-card w-[100%] border border-x-0 mt-3">
            <h1 className="text-[16px] font-semibold">
              Help us make mbook better
            </h1>
            <div className="">
              <div className="flex text-[12px] border bg-[#db631a] text-[#ffffff] rounded-md ml-3 pl-6 pr-6 p-1 cursor-pointer">
                <PiUserSoundFill className="mt-1 mr-2" /> Share Suggestion
              </div>
            </div>
          </Row>
          <Row className="w-[100%] bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mb-3">
            <h1 className="text-[#084d7b] account-sub-header font-medium">
              General details
            </h1>
          </Row>
          <Row className="w-[100%] pt-2 pb-2 pr-4 pl-4">
            <Col md={8} sm={24} xs={24} className="pr-10">
              <Typography className="input-account-required-label uppercase">
                Your Name <p className="text-[red] mx-1">*</p>
              </Typography>
              <Input
                name="name"
                value={accountData.name}
                onChange={(e) => handleChange(e)}
                placeholder="Enter Name"
                className="p-2  manage-business-button-label"
              />
              <p className="text-start text-[red] mt-2 mb-3">
                {simpleValidator.current.message(
                  "name",
                  accountData.name,
                  "required"
                )}
              </p>
            </Col>

            <Col md={8} sm={24} xs={24} className="pr-10">
              <Typography className="input-account-label uppercase">
                Mobile Number
              </Typography>
              <Input
                name="mobileNumber"
                maxLength={10}
                value={accountData.mobileNumber}
                onChange={(e) => handleChange(e)}
                disabled={!isEmpty(userDetailsMobile) ? true : false}
                placeholder="Enter Mobile Number"
                className="p-2 mt-1  manage-business-button-label"
              />
            </Col>

            <Col md={8} sm={24} xs={24} className="pr-10">
              <Typography className="input-account-label uppercase">
                Email
              </Typography>
              <Input
                name="email"
                value={email}
                id="main-input"
                onChange={validationChange}
                disabled={!isEmpty(userDetailsMail) ? true : false}
                placeholder="Enter Email"
                className="p-2 mt-1  manage-business-button-label"
              />
              <div
                id="error-panel"
                style={{
                  display: "none",
                  // marginTop: "-15px",
                  marginBottom: "10px",
                }}
              >
                {isEmpty(email) ? (
                  ""
                ) : (
                  <p className="text-start text-[#ff0000]">
                    The email or mobile field is not valid
                  </p>
                )}
              </div>
            </Col>
          </Row>
          <Row className="w-[100%] bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mt-3 mb-3">
            <h1 className="account-sub-header text-[#084d7b] font-medium">
              Referral code for subscription discount
            </h1>
          </Row>
          <Row className="w-[100%] pt-2 pb-2 pr-4 pl-4">
            <Col md={8} sm={24} xs={24} className="flex pr-10">
              <Input
                name="referralCode"
                value={accountData.referralCode}
                onChange={(e) => handleChange(e)}
                placeholder="Enter Referral Code"
                className="p-2  manage-business-button-label"
              />
            </Col>
            <div className="mt-2">
              <div className=" manage-business-button-label border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-1 pl-12 pr-12 p-1.5 cursor-pointer">
                Apply
              </div>
            </div>
          </Row>
        </Col>
        <Modal
          open={cancelConfirmation}
          onOk={() => {
            setCancelConfirmation(false);
            history.push("/dashboard");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => {
            setCancelConfirmation(false);
          }}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div
            style={{
              fontFamily: "Poppins",
            }}
            className="text-center w-[100%]"
          >
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
          </div>
        </Modal>
      </Row>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};
AccountSettings.propTypes = {
  location: PropTypes.any,
};

export default AccountSettings;
